import {Component, inject} from '@angular/core';
import {LocaleService} from "../../../../locale/locale.service";
import {AdditionalActionHeaderComponent} from "../additional-action-header/additional-action-header.component";
import {FooterComponent} from "../../../common/footer/footer.component";
import {ExpansionPanelComponent} from "../../../common/expansion-panel/expansion-panel.component";
import {RouterLink} from "@angular/router";
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-faq',
  imports: [
    AdditionalActionHeaderComponent,
    FooterComponent,
    ExpansionPanelComponent,
    RouterLink,
    NgOptimizedImage,
  ],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.css'
})
export class FaqComponent {
  locale = inject(LocaleService);
}
